// extracted by mini-css-extract-plugin
module.exports = {"node":"Node_node__2zhT8","nodeText":"Node_nodeText__gbv7m"};